import { render, staticRenderFns } from "./RobberyLeaveDateQuestion.vue?vue&type=template&id=58904ba0&scoped=true"
import script from "./RobberyLeaveDateQuestion.vue?vue&type=script&lang=ts"
export * from "./RobberyLeaveDateQuestion.vue?vue&type=script&lang=ts"
import style0 from "./RobberyLeaveDateQuestion.vue?vue&type=style&index=0&id=58904ba0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58904ba0",
  null
  
)

export default component.exports